import CloseIcon from "@mui/icons-material/Close";
import { Dialog, Skeleton, useMediaQuery } from "@mui/material";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DefaultServicesIcon, QRCode } from "../../constant/ImagesS3.js";
import {
  dialogDownloadAppLinks,
  dialogSocialIcons,
  downloadAppLinks,
  successSocialIcons,
} from "../../constant/staticData.js";
import { splitServiceNames } from "../../constant/utils.js";
import { useDialog } from "../../context/DialogContext.js";
import { styles } from "../SignUpFormVerification/styleSheet.js";

function ViewServiceDialog({ isDialogOpen, handleClose, service }) {
  const { handleDialogClose } = useDialog();
  const isSmallScreen = useMediaQuery("(max-width: 600px)");
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const [totalImages, setTotalImages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Set the total number of images dynamically based on links
    const total = downloadAppLinks?.length + successSocialIcons?.length + 4;
    setTotalImages(total);
  }, []);

  const handleModalClose = () => {
    handleClose();
    handleDialogClose();
  };

  const handleImageLoad = () => {
    setImagesLoaded((prevCount) => prevCount + 1);
  };

  useEffect(() => {
    if (imagesLoaded === totalImages) {
      setTimeout(() => setIsLoading(false), 1500);
    }
  }, [imagesLoaded, totalImages, isLoading]);

  if (!isDialogOpen) return null;

  return (
    <Dialog
      open={isDialogOpen}
      onClose={handleModalClose}
      maxWidth="sm"
      fullWidth
      sx={styles.CustomDialogBox(isSmallScreen)}
      slotProps={{
        backdrop: {
          style: styles.backdropStyles,
        },
      }}
      className="success-mui-dialog"
    >
      <div style={styles.CustomDialogContent}>
        <div style={styles.crossButtonBox}>
          <CloseIcon onClick={handleModalClose} sx={styles.crossIcon} />
        </div>
      </div>
      <div style={styles.CustomDialogDescBox}>
        <div style={styles.CustomServicesHeadBox}>
          <div style={styles.CustomServicesHead}>
            To Avail this service visit our app.
          </div>
          <div style={styles.CustomDialogText}>Download it now!!</div>
        </div>
        <div style={styles.CustomServiceCard}>
          <img
            src={service?.serviceIcon || DefaultServicesIcon}
            alt={service?.serviceName}
            style={styles.CustomServiceCardImg}
          />
          <div style={styles.CustomServiceCardName}>
            {splitServiceNames(service?.serviceName)}
          </div>
        </div>
        <div style={styles.CustomDialogQrBox}>
          {isLoading ? (
            <Skeleton variant="rectangular" width={200} height={200} />
          ) : (
            <img
              src={QRCode}
              alt="qr-code"
              style={styles.qrCodeImg}
              onLoad={handleImageLoad}
              loading="lazy"
            />
          )}
        </div>
        <div style={styles.CustomDialogServiceDesc}>
          Join now as a user or service provider.
          <br />
          Scan QR Code or Download from App/Play Store.
        </div>
        <div style={styles.CutomDialogImgBox}>
          {dialogDownloadAppLinks?.map((store) => (
            <Link key={store?.id} to={store?.url}>
              {isLoading ? (
                <Skeleton variant="rectangular" width={150} height={44} />
              ) : (
                <img
                  style={styles.CustomServiceStoreImg}
                  src={store?.img}
                  alt={store?.alt}
                  loading="lazy"
                  onLoad={handleImageLoad}
                />
              )}
            </Link>
          ))}
        </div>
        <div>
          <div style={styles.CustomDialogFollowUsText}>FOLLOW US FOR MORE</div>
          <div style={styles.CutomDialogSocialIconsBox}>
            {dialogSocialIcons?.map((item) => (
              <Link
                key={item.id}
                to={item.path}
                target="_blank"
                style={styles.CustomDialogSocialIconsLink}
              >
                {isLoading ? (
                  <Skeleton variant="circular" width={40} height={40} />
                ) : (
                  <img
                    src={item.icon}
                    alt={item.name}
                    style={styles.CustomDialogServiceSocialIcons}
                    onLoad={handleImageLoad}
                    loading="lazy"
                  />
                )}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Dialog>
  );
}

ViewServiceDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ViewServiceDialog;
